/**
 * Utility exports for cross-domain session management
 * Provides convenient re-exports of all cross-domain utilities
 */

// Cross-domain storage
export {
  CrossDomainStorage,
  createCrossDomainStorage,
  crossDomainStorage,
  type StorageAdapter,
  type SessionData,
  type CrossDomainStorageOptions,
} from "./crossDomainStorage";

// Domain detection
export {
  getDomainInfo,
  getEnvironmentConfig,
  isProductionDomain,
  isDevelopmentDomain,
  getCookieDomain,
  getViteAppOrigin,
  getNextJSAppOrigin,
  isAllowedOrigin,
  getDebugInfo,
  validateDomainConfig,
  getStorageType,
  isCrossDomainEnabled,
  getPostMessageTargets,
  type DomainInfo,
  type EnvironmentConfig,
} from "./domainDetection";

// Cookie management
export {
  CookieManager,
  SessionCookieManager,
  createCookieManager,
  createSessionCookieManager,
  cookieManager,
  type CookieOptions,
  type ChunkedCookieOptions,
  type CookieManagerOptions,
} from "./cookieManager";

// Cross-origin messaging
export {
  CrossOriginMessaging,
  SessionMessaging,
  createCrossOriginMessaging,
  createSessionMessaging,
  crossOriginMessaging,
  type CrossOriginMessage,
  type MessageHandler,
  type CrossOriginMessagingOptions,
} from "./crossOriginMessaging";
